/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Empty_BodyInputs */

const en_us2_plan_empty_body = /** @type {(inputs: Plan_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer builds one from your answers, and nothing starts until you review it.`)
};

const pt_br2_plan_empty_body = /** @type {(inputs: Plan_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O personal monta um a partir das suas respostas, e nada começa antes de você revisar.`)
};

const es_419_plan_empty_body = /** @type {(inputs: Plan_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador arma uno a partir de tus respuestas, y nada empieza hasta que lo revises.`)
};

const pt_pt2_plan_empty_body = /** @type {(inputs: Plan_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treinador cria um a partir das tuas respostas, e nada começa antes de o reveres.`)
};

const fr_fr2_plan_empty_body = /** @type {(inputs: Plan_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton coach en crée un à partir de tes réponses, et rien ne commence avant que tu l'aies revu.`)
};

const de_de2_plan_empty_body = /** @type {(inputs: Plan_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach erstellt einen aus deinen Antworten, und nichts startet, bevor du ihn geprüft hast.`)
};

const it_it2_plan_empty_body = /** @type {(inputs: Plan_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il coach ne crea una dalle tue risposte, e non parte nulla prima che tu la riveda.`)
};

/**
* | output |
* | --- |
* | "Your trainer builds one from your answers, and nothing starts until you review it." |
*
* @param {Plan_Empty_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_empty_body = /** @type {((inputs?: Plan_Empty_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Empty_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_empty_body(inputs)
	if (locale === "es-419") return es_419_plan_empty_body(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_empty_body(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_empty_body(inputs)
	if (locale === "de-DE") return de_de2_plan_empty_body(inputs)
	if (locale === "it-IT") return it_it2_plan_empty_body(inputs)
	return en_us2_plan_empty_body(inputs)
});
export { plan_empty_body as "plan.empty_body" }